import React, { Fragment, useContext, useEffect, useState } from "react";

// Provider
import { AppContext } from "../../components/AppProvider";

// Utils

// UI
import {
  closeLayerFn,
  ContainerNew,
  openLayerFn,
  RightMenu,
  SubMenu,
} from "../Layout";

import { ConfirmLayer } from "../../components/UI/Dialog";
import { RightMenuLayer } from "./RightMenuLayer";

export default props => {
  const { userinfo, cfg } = useContext(AppContext);

  // 다이얼로그 [[
  const [dialog, setDialog] = useState({
    title: "",
    msg: "",
  });

  const handleConfirm = () => {
    // handleConfirmDialog('확인', '전체내용 동의를 선택해 주세요.', '')

    handleConfirmDialog("확인", "내용에 동의 하겠습니까?", "");
  };

  const handleConfirmDialog = (title, msg) => {
    setDialog({
      title: title,
      msg: msg,
    });

    openLayerFn($(".confirm-layer"));
  };

  const handleCancelCB = () => {
    closeLayerFn($(".confirm-layer"));
  };

  const handleConfirmCB = () => {
    closeLayerFn($(".confirm-layer"));
  };
  // 다이얼로그 ]]

  useEffect(() => {});

  return (
    <Fragment>
      <ContainerNew
        Title={"문의하기"}
        dark={"dark"}
        leftMenu={SubMenu}
        goToUrl={"/mp"}
        rightMenu={RightMenu}
        bottom={<Bottom handleConfirm={handleConfirm} />}>
        <div className="contents">
          <div className="sub-contents">
            <div className="device-link-contain type4">
              <div>
                <div className="select-custom-box">
                  <a href={void 0} className="btn-select">
                    서비스 문의
                  </a>
                  <ul>
                    <li>
                      <a href={void 0}>서비스 문의</a>
                    </li>
                    <li>
                      <a href={void 0}>디바이스 문의</a>
                    </li>
                    <li>
                      <a href={void 0}>제휴 문의</a>
                    </li>
                    <li>
                      <a href={void 0}>기타문의</a>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <span className="tit">답변받을 이메일</span>
                <div className="txt-area">
                  <input type="text" placeholder="이메일을 입력해 주세요." />
                </div>
              </div>

              <div>
                <span className="tit">문의내용</span>
                <div className="txt-area">
                  <input type="text" placeholder="제목을 입력해 주세요." />
                </div>
                <div className="txtar-area">
                  <textarea></textarea>
                  <div className="txtarea-plc">
                    문의 내용을 입력해 주세요.
                    <br />
                    원활한 답변을 위해 단말기 모델, OS 정보, 버전정보를 입력해
                    주세요.
                  </div>
                </div>
                <div className="mark-left">
                  <s>!</s>
                  답변을 위해 회원님의 사용중인 단말기 정보, 휴대폰 번호, 이메일
                  주소를 수집합니다. 문제 해결 후 수집한 단말기 정보는
                  삭제합니다.
                </div>

                <div className="checkbox-line">
                  <label className="checkbox-custom">
                    <input type="checkbox" className="check-confirm" />
                    <i></i> 위 전체 내용에 동의합니다.
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ContainerNew>

      <div className="under-fixarea-emptybox"></div>

      <RightMenuLayer />

      <ConfirmLayer
        priv="priv"
        title={dialog.title}
        msg={dialog.msg}
        handleCancelCB={handleCancelCB}
        handleConfirmCB={handleConfirmCB}
      />
    </Fragment>
  );
};

const Bottom = ({ handleConfirm }) => {
  return (
    <Fragment>
      <div className="fix-area">
        <div>
          <div className="under-fix-btnarea">
            <a
              href={void 0}
              className="btn-full-confim open-confirm-layer"
              onClick={e => handleConfirm()}>
              <i></i> 확인
            </a>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
